import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";

const useHandleTitleChange = () => {
  const { pathname } = useLocation();
  const { id } = useParams();
  const paths = useSelector((state) => state.sidebar.paths);
  const TITLE = "Reports";
  const ADMINISTRATION = "Administration";

  useEffect(() => {
    if (pathname?.includes("/Layout/") && id && paths) {
      let path = paths[id];

      if (path) {
        document.title = path ? `${path}` : TITLE;
      }
    } else if (pathname?.includes("/Administration/")) {
      document.title = ADMINISTRATION;
    } else {
      if (document.title !== TITLE) {
        document.title = TITLE;
      }
    }
  }, [id, paths, pathname]);

  return null;
};

export default useHandleTitleChange;
